export const COOKIE_CONSENT_NAME = 'yourAppCookieConsent'

export const hasUserAcceptedCookies = (): boolean => {
    if (typeof window === 'undefined') return false
    return document.cookie.includes(`${COOKIE_CONSENT_NAME}=true`)
} 